export const timezoneOptions = [
  "Australia/ACT (EST)",
  "Australia/Adelaide (CST)",
  "Australia/Brisbane (EST)",
  "Australia/Broken_Hill (CST)",
  "Australia/Canberra (EST)",
  "Australia/Currie (EST)",
  "Australia/Darwin (CST)",
  "Australia/Eucla (CWST)",
  "Australia/Hobart (EST)",
  "Australia/LHI (LHST)",
  "Australia/Lindeman (EST)",
  "Australia/Lord_Howe (LHST)",
  "Australia/Melbourne (EST)",
  "Australia/North (CST)",
  "Australia/NSW (EST)",
  "Australia/Perth (WST)",
  "Australia/Queensland (EST)",
  "Australia/South (CST)",
  "Australia/Sydney (EST)",
  "Australia/Tasmania (EST)",
  "Australia/Victoria (EST)",
  "Australia/West (WST)",
  "Australia/Yancowinna (CST)",
  "Canada/Atlantic (AST)",
  "Canada/Central (CST)",
  "Canada/Eastern (EST)",
  "Canada/Mountain (MST)",
  "Canada/Newfoundland (NST)",
  "Canada/Pacific (PST)",
  "Chile(CLT)",
  "Columbia Time",
  "Egypt/Cairo(EET)",
  "Guatemala Time",
  "Ireland(GMT)",
  "Kuwait(AST)",
  "Kuwait(DST)",
  "US/Alaska (AKST)",
  "US/Aleutian (HAST)",
  "US/Arizona (MST)",
  "US/Central (CST)",
  "US/Costa Rica (CST)",
  "US/Eastern (EST)",
  "US/Hawaii (HST)",
  "US/Mountain (MST)",
  "US/Pacific (PST)",
];